window.addEventListener("turbolinks:load", () => {

	/* ---------------------------------- */
	/*  DARK WEB MONITORING: SELECT PAGE  */
	/* ---------------------------------- */

	if ( (window.location.href.indexOf("dark_web_monitoring/select") > -1) || (window.location.href.indexOf("lost_wallet") > -1) ) {

		// Clear Checkbox Selection on entry
		window.addEventListener("pageshow", () => {
		  $('input[type=checkbox]:checked').prop("checked", false)
		});

		// Function for form selection click events
		function selectInformation (element) {

			// Add background colour to selected boxes
			if ($(element).find('input[type=checkbox]:checked').length === 1) {
				$(element).find('input[type=checkbox]').prop("checked", false)
				$(element).closest('.select_box').toggleClass('selected');
			} else { 
				$(element).find('input[type=checkbox]').prop("checked", true)
				$(element).closest('.select_box').toggleClass('selected');
			}

			// Make Button Active if one or more selections are made
			if ($('input[type=checkbox]:checked').length > 0) {
				$("#show-me-btn").addClass("enabled");
			} else {
				$("#show-me-btn").removeClass("enabled");
			}
		}

		// Click Events
		$(function(){
			$('input[type=checkbox]').click(function() { 
				selectInformation($(this));
			});

			$('.select_box').click(function() { 
				selectInformation($(this));
			});
		});
	}

	/* ---------------------------------- */
	/*  DARK WEB MONITORING: ACTION PLAN  */
	/* ---------------------------------- */

		if ( (window.location.href.indexOf("dark_web_monitoring/actionplan") > -1) || (window.location.href.indexOf("lost_wallet/actionplan") > -1) ) {

		function selectConfirm (element) {
			$(element).closest('.info-confirm-box').toggleClass('selected');

			if ($(element).closest('.info-confirm-box').hasClass('selected')) {
				$(element).find('input').prop("checked", true);
			} else {
				$(element).find('input').prop("checked", false);
			}
			if ( ($('.info-confirm-box:visible').length) === ($('.info-confirm-box:visible').filter('.selected').length) ) {
				$('#actionplan-done').fadeIn();
			} else {
				$('#actionplan-done').fadeOut();
			}
		};

		$('.info-confirm-box').click(function(){
			if (window.actionPlanBreach) {
			} else {
			}
			selectConfirm($(this))
		});
			
		// Checkmark Click Event
		$('.checkmark').click(function(e){
			e.stopImmediatePropagation();
		});

		// Breach Guide Links
		$("#breach-guide-btn").click(function(){
			window.open($(this).attr("data-url"));
		});

		$("#breach-find-out-more-btn").click(function(){
			window.open($(this).attr("data-url"));
		});

		// Print Buttons
		$("#breach-print-btn-dark").click(function(){
			window.print();
		});

		$("#dwm-print-btn").click(function(){
			window.print();
		});

	}

});
